import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import './styles.css';

import App from './App.vue';
import { router } from './router';

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(ElementPlus);
app.mount('#app');

window.addEventListener('vite:preloadError', () => {
  if (sessionStorage.getItem('chunkReloaded')) return;
  sessionStorage.setItem('chunkReloaded', '1');
  window.location.reload();
});
router.afterEach(() => sessionStorage.removeItem('chunkReloaded'));

